<template>
    <CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="row mx-0  px-2">
            <div class=" col-xl-4 text-center btn-home my-2" v-for="(destino, index) in destinos" :key="index" v-if="destino.view">
                <button @click="mtdstoredata(destino)" type="button" class="btn w-100 fw-bold">
                     {{destino.label}}
                </button>
            </div>
        </div>
      <SweetAlert :swal="swal" ref="SweetAlert" />

    </CModal>
    </template>
    
    <script>
    import CModal from "@/components/shared/modals/CModal.vue";
    import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
    
    import {
        mapActions
    } from "vuex";
    
    export default {
        name: "c-asistencial-sop-modals-cModaldestino",
        components: {
            CModal,
            SweetAlert
        },
        data() {
            return {
                swal: null,
                destinos:[
                    {
                        id: 1,
                        label: "PRE OPERATORIO",
                        numProcess: 1,
                        view: this.process == 2,

                    },
                    {
                        id: 2,
                        label: "INTRA OPERATORIO",
                        numProcess: 2,
                        view: this.process == 1,
                    },
                    {
                        id: 3,
                        label: "POST OPERATORIO",
                        numProcess: 3,
                        view: this.process == 2,
                    },
                    {
                        id: 4,
                        label: "UCI",
                        view: this.process == 2,
                    },
                    {
                        id: 5,
                        label: "HOSPITALIZACION",
                        view: this.process == 2 || this.process == 3,
                    },
                    {
                        id: 6,
                        label: "ALTA",
                        view: this.process == 3,
                    }
                ]
            };
        },
        props: {
            title: String,
            boo_modal: Boolean,
            process: Number,
            medical_id: {
                type:Number,
                default: 0,
            },
            origin: String,
    
        },
        watch: {
            process(newVal) {
                if(newVal){
                    this.destinos.forEach(destino => {
                        destino.view = this.mtdShow(destino.id);
                    });
                }
            }
        },
        methods: {
            ...mapActions(["get", "post"]),
            mtdclosemodal() {
                this.$emit('mtdclosemodal')
            },
            mtdstoredata(destino){
                let msg = "Nuevo Destino: " + destino.label.toLowerCase();
                this.$refs.SweetAlert.showConfirmSimple2(msg,"¿Estás seguro del cambio?","warning","Cambiar") 
              .then((result) => {
                  if (result.value) {
                      this.saveDestination(destino);
                  }
              });
            },
            mtdShow(id){
              switch (id) {
                case 1:
                    return false;
                case 2:
                    return this.process == 1;
                case 3:
                    return this.process == 2;
                case 4:
                    return this.process == 2 || this.process == 3;
                case 5:
                    return  this.process == 3;
                case 6:
                    return this.process == 3;
                default:
                    break;
              }
            },
            saveDestination: function (destination) {
                //verificar si el destino es entre servicio o subprocesos
                if([4,5,6].includes(destination.id)){
                    //verificar cual es su componente padre
                    if(this.origin == 'offcanva'){
                        //viene del componente asistencialView,acomodar los destinos a la funcion storedata
                        let payload = destination.id == 4 ? 2 : (destination.id == 5 ? 1  :  0 );
                        this.$emit('mtdstoredata', payload,'ALTA'); 
                    }else{
                        this.$emit('mtdstoreDestinoFinal', destination); 
                    }
                }else{
                    this.saveDestinationSubProcces(destination);
                }
                
            },
            saveDestinationSubProcces: function (destination){
                this.post({
                    url: this.$store.getters.get__url + "/Sop/storeSopTransfers",
                    token: this.$store.getters.get__token,
                    params: {
                        id: this.medical_id,
                        destination: destination.label,
                        start: this.process == 1 ? 'PRE OPERATORIO' : (this.process == 2 ? 'INTRA OPERATORIO' : "POST OPERATORIO"),
                    },
                })
                .then((response) => {
                    this.$emit('mtdDestino', destination.id);
                    this.$refs.SweetAlert.showSuccess(response.message);
                    this.mtdclosemodal();
                })
                .catch((errors) => {
                    console.log(errors);
                });
            }
        },
    };
    </script>
    